// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"a29d7003","81":"44bdde5c","106":"29a37d26","245":"60f7df52","277":"88b4e35b","453":"2b54f994","457":"49655dce","492":"70b59dd3","547":"7e95e249","759":"85f23b9a","772":"d5eb3a2b","959":"878af632"}[chunkId] + ".chunk.js";
};